import { IInforme, TipoInforme, TipoInformeNameResolver } from "@/redux/models";
import { partidoCodigoArray } from "./listas";


/**
 * 
 * @param informe 
   @param array  Si es true, devuelve un array con los atributos del informe en una lista en la poscicion 1
 * @returns  El nombre del informe. con array = true, devuelve los atributos por separado
 */

const obtenerCalleYAltura = (informe: IInforme) => {
    if(informe.domicilios[0] !== undefined) {
        const calle = informe.domicilios[0].calle;
        const altura = informe.domicilios[0].alturas;
        return `${calle} ${altura}`.toUpperCase()
    }
}

const obtenerVelocidad = (informe: IInforme) => {
    const velocidad = informe.velocidad - 1;
    const labels = ['SIMPLE', 'URGENTE', 'EXPRESS', 'EN EL DÍA', 'CERTIFICADA']
    return labels[velocidad]
}
const obtenerTipoVehiculo = (informe: IInforme) => {
    //@ts-ignore
    const index = informe.tipoVehiculo - 1
    const labels = ['AUTOMÓVIL', 'MOTO']
    return labels[index]
}
const obtenerRadicacion = (informe: IInforme) => {
    //@ts-ignore
    const index = informe.radicacion - 1
    const labels = ['ACTUAL', 'HISTÓRICO']
    return labels[index]
}

type hideKeys = {
    calle?: boolean,
    altura?: boolean,
    velocidad?: boolean,
    domicilios?: boolean
}

export const obtenerNombreInforme = (informe: IInforme, array: boolean = false, hideKeys?: hideKeys) => {
    const tipoDeInforme = informe.tipo;
    let nombre = TipoInformeNameResolver[tipoDeInforme];
    let atributos: string[] = []
    switch (tipoDeInforme) {
        //capital
        case TipoInforme.DominioCapitalModerno:
            nombre = 'DOMINIO CAPITAL'
            atributos = ['velocidad', 'matricula-capital', 'domicilios']
            break;
        case TipoInforme.DominioCapitalAntiguo:
            nombre = 'DOMINIO CAPITAL'
            atributos = ['velocidad', 'zona', 'tomo', 'folio', 'domicilios']
            break;
        case TipoInforme.InhibicionCapitalFisica:
            nombre = 'INHIBICION CAPITAL'
            atributos = ['velocidad', 'nombre', 'apellido']
            break;
        case TipoInforme.InhibicionCapitalJuridica:
            nombre = 'INHIBICIÓN CAPITAL'
            atributos = ['velocidad', 'razonSocial']
            break;
        case TipoInforme.TitularidadCapital:
            nombre = 'TITULARIDAD'
            atributos = ['domicilios']
            break;
        case TipoInforme.BienesPersonalesCapitalFisica:
            nombre = 'BIENES PERSONALES'
            atributos = ['velocidad', 'nombre', 'apellido']
            break;
        case TipoInforme.BienesPersonalesCapitalJuridica:
            nombre = 'BIENES PERSONALES'
            atributos = ['velocidad', 'razonSocial']
            break;
        case TipoInforme.FrecuenciaCapital:
            nombre = 'FRECUENCIA CAPITAL'
            atributos = ['velocidad', 'matricula-capital', 'domicilios']
            break;
        case TipoInforme.EmpresarialCapitalFisica:
            nombre = 'INFORME EMPRESARIAL CAPITAL'
            atributos = ['velocidad', 'nombre', 'apellido']
            break;
        case TipoInforme.EmpresarialCapitalJuridica:
            nombre = 'INFORME EMPRESARIAL CAPITAL'
            atributos = ['velocidad', 'razonSocial']
            break;
        case TipoInforme.CopiaDeEscrituraYReglamentos:
            nombre = 'COPIA DE ESCRITURA'
            atributos = ['domicilios']
            break;
        case TipoInforme.TitularidadDominioCapital:
            nombre = '4B ADMINISTRADORES'
            atributos = ['domicilios']
            break;
        //provincia
        case TipoInforme.DominioProvinciaMatriculado:
            nombre = 'DOMINIO PROVINCIA'
            atributos = ['velocidad', 'matricula-provincia', 'partido']
            break;
        case TipoInforme.DominioProvinciaNoMatriculado:
            nombre = 'DOMINIO PCIA NO MATRICULADO'
            atributos = ['velocidad', 'folio', 'anio', 'partido']
            break;
        case TipoInforme.InhibicionProvinciaFisica:
            nombre = 'INHIBICIÓN PROVINCIA'
            atributos = ['velocidad', 'nombre', 'apellido']
            break;
        case TipoInforme.InhibicionProvinciaJuridica:
            nombre = 'INHIBICIÓN PROVINCIA'
            atributos = ['velocidad', 'razonSocial']
            break;
        case TipoInforme.CesionProvinciaFisica:
            nombre = 'CESIÓN PROVINCIA'
            atributos = ['velocidad', 'nombre', 'apellido']
            break;
        case TipoInforme.CesionProvinciaJuridica:
            nombre = 'CESIÓN PROVINCIA'
            atributos = ['velocidad', 'razonSocial']
            break;
        case TipoInforme.FrecuenciaProvincia:
            nombre = 'FRECUENCIA PROVINCIA'
            atributos = ['velocidad', 'matricula-provincia', 'partido']
            break;
        case TipoInforme.ConsultaIndiceTitularesProvinciaFisica:
            nombre = 'CONSULTA AL ÍNDICE'
            atributos = ['velocidad', 'nombre', 'apellido']
            break;
        case TipoInforme.ConsultaIndiceTitularesProvinciaJuridica:
            nombre = 'CONSULTA AL ÍNDICE'
            atributos = ['velocidad', 'razonSocial']
            break;
        case TipoInforme.EmpresarialProvinciaFisica:
            nombre = 'INFORME EMPRESARIAL PROVINCIA'
            atributos = ['velocidad', 'nombre', 'apellido']
            break;
        case TipoInforme.EmpresarialProvinciaJuridica:
            nombre = 'INFORME EMPRESARIAL PROVINCIA'
            atributos = ['velocidad', 'razonSocial']
            break;
        case TipoInforme.CopiaDeEscrituraYReglamentosProvincia:
            nombre = 'COPIA DE ESCRITURA PROVINCIA'
            atributos = []
            break;
        //catastro
        case TipoInforme.PlanoMensuraSubdivicionCapital:
            nombre = 'COPIA DE PLANO MH'
            atributos = ['domicilios']
            break;
        case TipoInforme.PlanoMensuraSubdivicionProvincia:
            nombre = 'COPIA DE PLANO SUBDIVISION PROVINCIA'
            atributos = ['domicilios']
            break;
        case TipoInforme.PlanoObraCapital:
            nombre = 'COPIA DE PLANO DE OBRA CAPITAL'
            atributos = ['domicilios']
            break;
        case TipoInforme.PlanoObraSanitariaCapitalCatastro:
            nombre = 'COPIA DE PLANO AySA'
            atributos = ['domicilios']
            break;
        case TipoInforme.PlanchetaCapital:
            nombre = 'PLANCHETA CAPITAL'
            atributos = ['domicilios']
            break;
        case TipoInforme.ValuacionFiscalCapital:
            nombre = 'VALUACIÓN FISCAL CAPITAL'
            atributos = ['domicilios']
            break;
        case TipoInforme.EstudioPrefectibilidadCapitalCatastro:
            nombre = 'ESTUDIO DE PREFACTIBILIDAD'
            atributos = ['domicilios']
            break;
        case TipoInforme.EstadoParcelarioCapitalCatastro:
            nombre = 'ESTADO PARCELARIO'
            atributos = ['domicilios']
            break;
        case TipoInforme.ValuacionFiscalP:
            nombre = 'VALUACIÓN FISCAL PROVINCIA'
            atributos = ['partido'] //TODO: ver
            break;
        case TipoInforme.CedulaCatastralProvincia:
            nombre = 'CEDULA CATASTRAL'
            atributos = ['partido'] //TODO: ver
            break;
        case TipoInforme.CertificadoCatastralP:
            nombre = 'CERTIFICADO CATASTRAL'
            atributos = ['partido'] //TODO: ver
            break;
        case TipoInforme.PlanchetaDistribucionParcelariaP:
            nombre = 'PLANCHETA PROVINCIA'
            atributos = ['partido', 'nroPartidaArba']
            break;
        case TipoInforme.EstudioPrefectibilidadProvinciaCatastro:
            nombre = 'ESTUDIO DE PREFACTIBILIDAD'
            atributos = ['domicilios', 'partido']
            break;
        case TipoInforme.EstadoParcelarioProvinciaCatastro:
            nombre = 'ESTADO PARCELARIO'
            atributos = ['domicilios', 'partido']
            break;
        //? OTROS
        case TipoInforme.DominioAutomotor:
            nombre = 'DOMINIO AUTOMOTOR'
            atributos = ['radicacion', 'tipoVehiculo', 'patente']
            break;
        case TipoInforme.InhibicionAutomotorFisica:
            nombre = 'INHIBICIÓN AUTOMOTOR'
            atributos = ['nombre', 'apellido']
            break;
        case TipoInforme.InhibicionAutomotorJuridica:
            nombre = 'INHIBICIÓN AUTOMOTOR'
            atributos = ['razonSocial']
            break;
        case TipoInforme.Patentamiento:
            nombre = 'CONSULTA POR PATENTAMIENTO'
            atributos = []
            break;
        case TipoInforme.Transferencia:
            nombre = 'CONSULTA POR TRANSFERENCIA'
            break;
        case TipoInforme.PartidaDefuncion:
            nombre = 'PARTIDA DE DEFUNCIÓN'
            atributos = ['nombre', 'apellido']
            break;
        case TipoInforme.PartidaMatrimonio:
            nombre = 'PARTIDA DE MATRIMONIO'
            atributos = ['conyugeConcuvino1', 'conyugeConcuvino2']
            break;
        case TipoInforme.PartidaNacimiento:
            nombre = 'PARTIDA DE NACIMIENTO'
            atributos = ['nombre', 'apellido']
            break;
        case TipoInforme.PartidaUnionConvivencial:
            nombre = 'PARTIDA DE UNIÓN CONVIVENCIAL'
            atributos = ['conyugeConcuvino1', 'conyugeConcuvino2']
            break;
        case TipoInforme.InscripcionOficiosPoC:
            nombre = 'CONSULTA POR INSCRIPCIÓN DE OFICIOS'
            atributos = []
            break;
        case TipoInforme.InformeGeneralInterior:
            nombre = 'INTERIOR DEL PAIS'
            atributos = []
            break;
        default:
            return TipoInformeNameResolver[tipoDeInforme];
    }
    const atributosBuilder = atributos.map((a) => {
        switch (a) {
            case 'velocidad':
                if (hideKeys === undefined || !hideKeys.velocidad) {
                    return ` (${obtenerVelocidad(informe)})`
                }
                break;
            case 'conyugeConcuvino1':
                    //@ts-ignore    
                    return `${informe?.conyugeConcuvino1?.nombre + ' ' + informe?.conyugeConcuvino1?.apellido + ' - '}`
            case 'conyugeConcuvino2':
                    //@ts-ignore    
                    return `${informe?.conyugeConcuvino2?.nombre + ' ' + informe.conyugeConcuvino2?.apellido}`
            case 'domicilios':
                if (hideKeys === undefined || !hideKeys.domicilios) {
                    return ` ${obtenerCalleYAltura(informe)}`
                }
                break;
            case 'matricula-provincia':
                //@ts-ignore
                return `MATRICULA ${informe.matricula}`
            case 'matricula-capital':
                //@ts-ignore
                return `FR ${informe.matricula}`
            case 'tomo':
                //@ts-ignore
                return `TOMO ${informe.tomo}`
            case 'folio':
                //@ts-ignore
                if(informe.folio !== undefined && informe.folio !== "" && informe.folio !== " "){
                    //@ts-ignore
                    return `FOL ${informe.folio}`
                }else{
                    return ""
                }
            case 'anio':
                //@ts-ignore
                if(informe.anio !== undefined && informe.anio !== "" && informe.anio !== " "){
                    //@ts-ignore
                    return `AÑO ${informe.anio}`
                }else{
                    return ""
                }
            case 'tipoVehiculo':
                return obtenerTipoVehiculo(informe)
            case 'partido':
                //@ts-ignore
                return partidoCodigoArray.find((p) => p.codigo === Number(informe.partido))?.partido
            case 'radicacion':
                return obtenerRadicacion(informe)
            default:
                //@ts-ignore
                return `${informe[a]}`.toUpperCase()
        }
        return ''
    }).join(' ')

    if (array) {
        return [nombre, atributosBuilder]
    }
    return `${nombre} ${atributosBuilder}`
}